"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenuToggleContainer = exports.StyledModalContainer = exports.StyledModal = exports.PopoverMenuLink = exports.StyledChevronRight = exports.PopoverMenuItem = exports.StyledMenuToggleLink = exports.StyledMenuItemLink = exports.PopoverMenuContainer = exports.PopoverContainer = exports.StyledNavMenuItem = exports.StyledMenuListItem = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

var _colors = require("../../../utils/colors");

var _Link = require("../../Link");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  svg {\n    margin-left: 10px;\n    fill: ", ";\n    g {\n      fill: ", ";\n    }\n  }\n  &:hover {\n    svg {\n      fill: ", ";\n      g {\n        fill: ", ";\n      }\n    }\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  align-items: ", ";\n  width: inherit;\n  height: inherit;\n  color: inherit;\n  display: inherit;\n  flex-direction: inherit;\n  justify-content: flex-start;\n  max-width: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  justify-content: ", ";\n  align-items: flex-start;\n  padding: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  padding: 0px 0px 16px 16px;\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n\n  :hover {\n    & ", " {\n      visibility: visible;\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  visibility: hidden;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  margin: 0;\n  box-sizing: border-box;\n  width: 100%;\n  white-space: nowrap;\n  text-align: left;\n  font-weight: 400;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background-position: left 0 bottom 0.55rem;\n  color: inherit;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  z-index: 1;\n\n  :visited {\n    color: inherit;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background-position: left 0 bottom 0.55rem;\n  color: inherit;\n  font-family: ", ";\n  font-size: ", ";\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  z-index: 1;\n\n  :visited {\n    color: inherit;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  visibility: hidden;\n  transform: translate(0, 10px);\n  background-color: ", ";\n  box-shadow: 0 4px 10px 0 rgba(11, 41, 68, 0.3);\n  border-radius: 5px;\n  height: auto;\n  box-sizing: border-box;\n  overflow: unset;\n  padding: 18px 32px 20px 16px;\n  top: 50px;\n\n  * {\n    visibility: hidden;\n  }\n\n  ", ":hover & {\n    z-index: 10;\n    opacity: 1;\n    visibility: visible;\n    transform: translate(0, -25px);\n    transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n\n    * {\n      visibility: visible;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 65px;\n  background-color: transparent;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  visibility: hidden;\n\n  ", ":hover & {\n    visibility: visible;\n    top: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-clip: content-box;\n  height: fit-content;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  font-weight: 700;\n  position: relative;\n  padding: 0px;\n\n  @media screen and (min-width: ", ") {\n    padding: 0px 15px;\n\n    svg {\n      path {\n        fill: ", ";\n      }\n      padding-bottom: 9px;\n      z-index: 1;\n    }\n\n    :hover {\n      cursor: pointer;\n      color: ", ";\n\n      svg {\n        path {\n          fill: ", ";\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ChevronRight = function ChevronRight(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }));
};

ChevronRight.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var StyledMenuListItem = _styledComponents.default.li(_templateObject(), function (props) {
  return (0, _colors.normaliseColor)(props.theme.Nav.textColor, props.theme);
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.Nav.textColor, props.theme);
}, function (props) {
  return props.theme.colors.actionPrimary300;
}, function (props) {
  return props.theme.colors.actionPrimary300;
});

exports.StyledMenuListItem = StyledMenuListItem;

var StyledNavMenuItem = _styledComponents.default.div(_templateObject2());

exports.StyledNavMenuItem = StyledNavMenuItem;

var PopoverContainer = _styledComponents.default.div(_templateObject3(), StyledNavMenuItem);

exports.PopoverContainer = PopoverContainer;

var PopoverMenuContainer = _styledComponents.default.ul(_templateObject4(), function (props) {
  return props.theme.colors.white;
}, StyledNavMenuItem);

exports.PopoverMenuContainer = PopoverMenuContainer;
var StyledMenuItemLink = (0, _styledComponents.default)(_Link.Link)(_templateObject5(), function (props) {
  return props.theme.Nav.fontStyle.fontFamily;
}, function (props) {
  return props.theme.Nav.fontSize;
});
exports.StyledMenuItemLink = StyledMenuItemLink;
var StyledMenuToggleLink = (0, _styledComponents.default)(_Link.Link)(_templateObject6());
exports.StyledMenuToggleLink = StyledMenuToggleLink;

var PopoverMenuItem = _styledComponents.default.li(_templateObject7());

exports.PopoverMenuItem = PopoverMenuItem;
var StyledChevronRight = (0, _styledComponents.default)(ChevronRight)(_templateObject8());
exports.StyledChevronRight = StyledChevronRight;
var PopoverMenuLink = (0, _styledComponents.default)(_Link.Link)(_templateObject9(), StyledChevronRight, function (props) {
  return props.theme.colors.actionPrimary300;
});
exports.PopoverMenuLink = PopoverMenuLink;
var StyledModal = (0, _styledComponents.default)(function (props) {
  return _react.default.createElement(_.Modal, props);
})(_templateObject10(), function (props) {
  return props.theme.Nav.modal.justifyContent;
}, function (props) {
  return props.theme.Nav.modal.padding;
});
exports.StyledModal = StyledModal;

var StyledModalContainer = _styledComponents.default.div(_templateObject11(), function (props) {
  return props.theme.Nav.modal.alignItems;
}, function (props) {
  return props.theme.Nav.modal.maxWidth;
});

exports.StyledModalContainer = StyledModalContainer;

var StyledMenuToggleContainer = _styledComponents.default.div(_templateObject12(), function (props) {
  return (0, _colors.normaliseColor)(props.theme.Nav.textColor, props.theme);
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.Nav.textColor, props.theme);
}, function (props) {
  return props.theme.colors.actionPrimary300;
}, function (props) {
  return props.theme.colors.actionPrimary300;
});

exports.StyledMenuToggleContainer = StyledMenuToggleContainer;